<template>
    <section>
        <!--<div class="background-container">-->
            <!--<div class="bg-main"></div>-->
            <!--<div class="bg-center valign">-->
                <!--<Spiral></Spiral>-->
            <!--</div>-->
            <!--<div class="bg bg__tl">-->
                <!--<img src="/static/images/grill.png" alt="Grill">-->
            <!--</div>-->
            <!--<div class="bg bg__bl"></div>-->
            <!--<div class="bg bg__tr"></div>-->
            <!--<div class="bg bg__br"></div>-->
        <!--</div>-->
        <h3 class="section-title">Тест</h3>
        <div class="text-container text-container__result valign">

            <div class="result-top">
                <h3 class="text-title">Неплохой результат!</h3>
                <div class="text-main">
                    <p>Вы сможете провести почти два месяца BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.</p>
                </div>
            </div>
            <div class="result-bottom clearfix">
                <div class="text-main">
                        <p>Лучше иметь «БАКТИСТАТИН»
                        под рукой для себя или увлекающихся BBQ близких.</p>
                    <span>узнать больше</span><Arrow></Arrow>
                </div>
                <div class="image-right">
                    <img src="/static/images/baktistatin.png" alt="Baktistatin">
                    <img class="shadow" src="/static/images/shadow.png" alt="Baktistatin">
                </div>
            </div>
            <router-link to="/" class="btn">далее</router-link>
        </div>
    </section>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Arrow from '../../assets/svg/arrow-long.svg';

    export default {
        name: 'Result',
        components: {
            Arrow
        }
    }
</script>


// WEBPACK FOOTER //
// Result.vue?55a2903d